import { Directive, ElementRef, Inject, Input, Renderer2 } from '@angular/core';
import {
  DATE_OPTIONS,
  DateOptions,
  MarketplaceItemAttribute,
  MarketplaceItemAttributeDisplayType,
  MarketplaceItemAttributeValue,
  MarketplaceItemMappingAttribute,
  WalletAttributes,
} from '@fgb/core';
import { UtcToLocaltimePipe } from '@fgb/portal-component-library/src/lib/pipes';

function attributeTransform(data: number | MarketplaceItemMappingAttribute): number | MarketplaceItemMappingAttribute {
  if (typeof data === 'object' && 'AttributeMappingId' in data) {
    let d = new MarketplaceItemMappingAttribute();
    d.AttributeValues = data.AttributeValues;
    d.AttributeMappingId = data.AttributeMappingId;
    d.DisplayName = data.DisplayName;
    return d;
  }

  return data;
}

@Directive({
  selector: '[fgbclAttributeTransValue]',
  standalone: true,
})
export class AttributeTransValueDirective {
  private _data: number | MarketplaceItemMappingAttribute;
  @Input() isWallet: boolean = false;
  @Input({ alias: 'attributeDataOrId', required: true, transform: attributeTransform }) set data(
    value: number | MarketplaceItemMappingAttribute
  ) {
    if (value) {
      this._data = value;
      this.displayAttributeValue();
    }
  }
  @Input({ required: true }) attributeList: MarketplaceItemAttribute[];

  constructor(
    @Inject(DATE_OPTIONS) private dateOptions: DateOptions,
    private renderer: Renderer2,
    private _el: ElementRef
  ) {}

  displayAttributeValue(): void {
    let value: string | undefined = '';

    const childElements = this._el.nativeElement.childNodes;
    for (let child of childElements) {
      this.renderer.removeChild(this._el.nativeElement, child);
    }

    if (this.isWallet) {
      const id = this._data;
      const walletAttributeList: WalletAttributes[] = this.attributeList as unknown as WalletAttributes[];
      const attribute: WalletAttributes | undefined = walletAttributeList.find((attr) => attr.LogId === id);
      if (attribute?.DisplayType === MarketplaceItemAttributeDisplayType.Date) {
        const utcToLocalPipe = new UtcToLocaltimePipe();
        if (attribute.DisplayValue && attribute.DisplayValue !== '' && attribute.DisplayValue.trim()) {
          value = attribute.DisplayValue;
        } else {
          value = utcToLocalPipe.transform(attribute?.AttributeValue, this.dateOptions.LongDateFormat);
        }
      } else {
        value = attribute?.DisplayValue;
      }
    } else {
      if (this._data instanceof MarketplaceItemMappingAttribute) {
        const attribute: MarketplaceItemMappingAttribute = this._data;
        const mappedAttribute = this.attributeList.find((attr: MarketplaceItemAttribute) =>
          attr.Values?.some((val: MarketplaceItemAttributeValue) =>
            attribute.AttributeValues?.some((x: number) => x === val.RewardValueId)
          )
        );
        const mappedValueAttribute = mappedAttribute?.Values?.find((val: MarketplaceItemAttributeValue) =>
          attribute.AttributeValues?.some((x: number) => x === val.RewardValueId)
        );
        if (mappedAttribute && mappedAttribute.DisplayType === MarketplaceItemAttributeDisplayType.Date) {
          const utcToLocalPipe = new UtcToLocaltimePipe();
          if (
            mappedValueAttribute?.DisplayName &&
            mappedValueAttribute?.DisplayName !== '' &&
            mappedValueAttribute?.DisplayName.trim()
          ) {
            value = mappedValueAttribute?.DisplayName;
          } else {
            value = utcToLocalPipe.transform(mappedValueAttribute?.AttributeValue, this.dateOptions.LongDateFormat);
          }
        } else {
          value = mappedValueAttribute?.DisplayName || this._data.DisplayName;
        }
      } else {
        const id = this._data;
        const mappedAttribute: MarketplaceItemAttribute | undefined = this.attributeList.find((attr) =>
          attr.Values?.some((val: MarketplaceItemAttributeValue) => val.RewardValueId === id)
        );
        const attribute = mappedAttribute?.Values?.find((val: any) => val.RewardValueId === id);

        if (attribute && mappedAttribute?.DisplayType === MarketplaceItemAttributeDisplayType.Date) {
          const utcToLocalPipe = new UtcToLocaltimePipe();
          if (attribute.DisplayName && attribute.DisplayName !== '' && attribute.DisplayName.trim()) {
            value = attribute.DisplayName;
          } else {
            value = utcToLocalPipe.transform(attribute?.AttributeValue, this.dateOptions.LongDateFormat);
          }
        } else {
          value = attribute?.DisplayName;
        }
      }
    }

    const text = this.renderer.createText(`${value}`);
    this.renderer.appendChild(this._el.nativeElement, text);
  }
}
